import { createSlice } from '@reduxjs/toolkit';
import BaseError from 'utils/base-error';
import { z } from 'zod';
// eslint-disable-next-line no-restricted-imports
import { createStrapiMediaUrl, fetchLeadFormThunk } from 'shared/lib';
import { createCulinaryStudioArticleFromGetCulinaryStudioArticleApiResponse } from '../utils';
import { CulinaryStudioArticlePageState } from './state';
import { CulinaryStudioArticlePageActions } from './actions';

const initialState: CulinaryStudioArticlePageState = {
    loaded: false,
    errors: [],
};

export const culinaryStudioArticlePageSlice = createSlice({
    name: 'culinaryStudioArticlePageSlice',
    initialState,
    reducers: {},
    extraReducers(builder) {
        /**
         * Получение записи по uid
         */
        builder.addCase(
            CulinaryStudioArticlePageActions.getCulinaryStudioArticleByUid.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        // eslint-disable-next-line max-len
                        const result = createCulinaryStudioArticleFromGetCulinaryStudioArticleApiResponse(
                            response.data,
                        );
                        state.culinaryStudioArticle = result;
                        state.loaded = true;
                    } catch (e) {
                        if (e instanceof z.ZodError) {
                            state.errors.push(new BaseError(400, e.message));
                        } else {
                            state.errors.push(new BaseError(400, String(e)));
                        }
                    }
                }
            },
        );
        builder.addCase(
            fetchLeadFormThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.leadFormPdf = response.data.data.commercialOfferFile ? {
                        url: createStrapiMediaUrl(response.data.data.commercialOfferFile.url),
                    } : undefined;

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});
